import type { ButtonHTMLAttributes } from 'react';
import { focusableClassName } from '../helpers/spatialFocus';
import { getAssetUrl } from '../lib/assets';
import { classNames } from '../lib/classNames';
import { AsyncImage } from './AsyncImage';

interface ChannelCardProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  image?: string;
  label: string;
}

export const ChannelCard = ({
  className,
  image,
  label,
  ...props
}: ChannelCardProps) => (
  <button
    type="button"
    className={classNames('channel-card', focusableClassName, className)}
    {...props}
  >
    <span className="channel-card-label">{label}</span>
    <span className="block p-4">
      <AsyncImage
        src={getAssetUrl(image)}
        alt={label}
        className="channel-card-image"
      />
    </span>
  </button>
);
